export default "__VITE_ASSET__Dj4DbZ6q__"